import { useCallback, useEffect, useState, useContext } from "react";
import { FileState, GetAssetSizeResponse } from "../../proto/api_pb";
import { GetTrackFilesResponse } from "../../proto/api_pb";
import { RpcError } from "grpc-web";
import { Box, Typography, LinearProgress } from "@mui/material";
import { formatFileSize, getAssetSize } from "../../services/trackService";
import { fetchTrackFiles } from "../../services/trackService";
import { TrackFiles } from "./TrackFile";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { FileObj } from "./types";
import { AuthContext } from "../../contexts";
import { styles } from "./styles";

export const TrackFileGroup: React.FC<{
  id: string | undefined;
  isFileAdded?: boolean;
  allowDownload?: boolean | undefined;
  shareToken?: string;
}> = ({ id, isFileAdded, allowDownload, shareToken }) => {
  const [trackFiles, setTrackFiles] = useState<FileObj[]>([]);
  const { getValidAccessToken } = useGetValidAccessToken();
  const { userId } = useContext(AuthContext);
  const [pageLoaded, setPageLoaded] = useState(false);
  const isSharedContentPage = window.location.pathname.includes("/share/");

  const handleFetchTrackFiles = useCallback(async () => {
    const token = isSharedContentPage
      ? shareToken ?? ""
      : await getValidAccessToken();
    try {
      const response = (await fetchTrackFiles(
        token,
        id!,
        userId
      )) as GetTrackFilesResponse;
      const tempTrackFilesList = response.getTrackFilesList();
      const filesObjList: FileObj[] = [];
      for (const file of tempTrackFilesList) {
        if (file.getFileState() === FileState.FILE_STATE_ACTIVE) {
          try {
            const fileSize = (await getAssetSize(
              token,
              file.getFileUrl()
            )) as GetAssetSizeResponse;

            filesObjList.push({
              trackFile: file,
              fileSize: fileSize.getSizeGb() ? fileSize.getSizeGb() : 0,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      setTrackFiles([...filesObjList]);
      setPageLoaded(true);
    } catch (e) {
      const error = e as RpcError;
      console.log(error.code);
      console.log(error.message);
    }
    // eslint-disable-next-line
  }, [getValidAccessToken, id, isFileAdded]);

  useEffect(() => {
    handleFetchTrackFiles();
  }, [handleFetchTrackFiles]);

  const handleOpenDeleteModal = (id: string) => {};
  return (
    <>
      <Box>
        {pageLoaded && trackFiles.length > 0 && (
          <Typography sx={styles.typographyContainer} variant="h6"></Typography>
        )}
        <Box sx={styles.trackFilesBox}>
          {trackFiles &&
            trackFiles.map((el: FileObj, i) => {
              const url = el.trackFile.getFileUrl();
              const id = el.trackFile.getId();
              const label = el.trackFile.getLabel();
              const fileName = el.trackFile.getFilename();
              const type = el.trackFile.getType();
              const timeStamp = el.trackFile.getTimestamp();
              const ownerId = el.trackFile.getOwnerId();
              const fileSize = el.fileSize;
              return (
                <>
                  <TrackFiles
                    fileId={id}
                    key={i}
                    url={url}
                    label={label}
                    timeStamp={timeStamp}
                    ownerId={ownerId}
                    fileName={fileName}
                    fileType={type}
                    fileSize={fileSize ? formatFileSize(fileSize) : "-"}
                    handleOpenDeleteModal={handleOpenDeleteModal}
                    collaborators={el.trackFile.getCollaboratorsList()}
                    file={el.trackFile}
                    allowDownload={allowDownload}
                  />
                </>
              );
            })}
        </Box>
        {!pageLoaded && (
          <Box sx={styles.linearProgressMainContainer}>
            <Box sx={styles.linearProgressContainer}>
              <LinearProgress color="inherit" />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};
